import React, { createContext, useState, useCallback } from "react";

export const PreOnboardingContext = createContext();

export const PreOnboardingProvider = ({ children }) => {
  const [preOnboardingState, setPreOnboardingState] = useState({
    activeInnerStep: 0,
    uploadedFiles: {},
    documentErrors: {},
    validationErrors: {},
    formValues: {
      driverName: "",
      mobileNumber: "",
      alternateMobileNumber: "",
      residentialAddress: "",
      age: "",
      vehicleFinanced: "",
      vehicleFinancierName: "",
      vehicleFinancierAddress: "",
      vehicleFinancierPhone: "",
    },
  });

  const updatePreOnboardingState = useCallback((updates) => {
    setPreOnboardingState((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const resetPreOnboardingState = useCallback(() => {
    setPreOnboardingState({
      activeInnerStep: 0,
      uploadedFiles: {},
      documentErrors: {},
      validationErrors: {},
      formValues: {
        driverName: "",
        mobileNumber: "",
        alternateMobileNumber: "",
        residentialAddress: "",
        age: "",
        vehicleFinanced: "",
        vehicleFinancierName: "",
        vehicleFinancierAddress: "",
        vehicleFinancierPhone: "",
      },
    });
  }, []);

  return (
    <PreOnboardingContext.Provider
      value={{
        preOnboardingState,
        updatePreOnboardingState,
        resetPreOnboardingState,
      }}
    >
      {children}
    </PreOnboardingContext.Provider>
  );
};
